import { registerBlockType } from "@wordpress/blocks";
import { Provider } from "react-redux";
import { Icon } from "@wordpress/components";
import store from "store";
import Editor from "./Edit";
import Save from "./Save";

registerBlockType("vino/login", {
	title: "Login",
	icon: {
		src: <Icon icon="lock" />,
	},
	category: "corksy",
	keywords: ["corksy"],
	description: "Login.",
	edit: function (props) {
		return (
			<Provider store={store}>
				<Editor {...props} />
			</Provider>
		);
	},
	save: Save,
});
